import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ReferrerAuthenticationService } from '../services/referrerAuthentication.service';

@Injectable({ providedIn: 'root' })
export class ReferrerAuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private referrerAuthService: ReferrerAuthenticationService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const currentUser = this.referrerAuthService.getCurrentUser();

    if (currentUser) {
      return true;
    }
    localStorage.setItem('returnURL', state.url);
    localStorage.setItem('returnURLParameters', JSON.stringify(route.queryParams));
    this.router.navigate(['/referrerLogin'], { });

    return false;
  }

}
